import { $ABTest } from '@lemon8/webapp-shared/model';
import { Atom, atom } from 'jotai';
import _get from 'lodash/get';

/**
 * 0: control group
 * 1: Image on Gallery page with OCR & new alternate text
 */
export const $SEOImgOCR: Atom<number> = atom((get) => {
  const { parameters } = get($ABTest);
  if (__BUILD_TYPE__ === 'local_dev') {
    return 1;
  }
  return _get(parameters, ['seo_web', 'lemon8.seo_img_ocr'], 0);
});

export const $HitSEOImgOCR: Atom<boolean> = atom((get) => {
  const ocrExpConfig = get($SEOImgOCR);
  return ocrExpConfig === 1;
});
